/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Design_Title6Inputs */

const en_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool and resource design`)
};

const ar_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم الأدوات والموارد`)
};

const bn_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল ও রিসোর্স ডিজাইন`)
};

const de_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool- und Ressourcen-Design`)
};

const es_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño de herramientas y recursos`)
};

const fr_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception d'outils et de ressources`)
};

const pt_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenho de ferramentas e recursos`)
};

const zh_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具与资源设计`)
};

const tr_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç ve kaynak tasarımı`)
};

const ru_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайн инструментов и ресурсов`)
};

const pl_svc_mcp_server_development_design_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt narzędzi i zasobów`)
};

/**
* | output |
* | --- |
* | "Tool and resource design" |
*
* @param {Svc_Mcp_Server_Development_Design_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_design_title6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Design_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Design_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_design_title6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_design_title6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_design_title6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_design_title6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_design_title6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_design_title6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_design_title6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_design_title6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_design_title6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_design_title6(inputs)
	return en_svc_mcp_server_development_design_title6(inputs)
});
export { svc_mcp_server_development_design_title6 as "svc_mcp-server-development_DESIGN_title" }